var _desc, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunityServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Community Service Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Community service and helping hands icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 45 L30 40 L35 45 L40 40 L45 45 L45 60 L40 65 L35 60 L30 65 L25 60 Z",
    fill: "#5F7A61",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55 45 L60 40 L65 45 L70 40 L75 45 L75 60 L70 65 L65 60 L60 65 L55 60 Z",
    fill: "#5F7A61",
    stroke: "#E5DECF",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52 C50 52, 40 42, 40 35 A5 5 0 0 1 45 30 A5 5 0 0 1 50 35 A5 5 0 0 1 55 30 A5 5 0 0 1 60 35 C60 42, 50 52, 50 52 Z",
    fill: "#F5F0E6",
    stroke: "#E5DECF",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    r: 18,
    fill: "none",
    stroke: "#E5DECF",
    strokeWidth: 2,
    strokeDasharray: "3,3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 75,
    r: 3,
    fill: "#5F7A61"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    r: 3,
    fill: "#5F7A61"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 75,
    r: 3,
    fill: "#5F7A61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunityServiceIcon);
export default __webpack_public_path__ + "static/media/community-service-icon.b8ece1447c07c7dc55c90be9a58bcc69.svg";
export { ForwardRef as ReactComponent };